import Swal from 'sweetalert2';
import hook from '../../scripts/utilities/hook';

const TRIGGER_SELECTOR = hook('js-terms-trigger');
const TERMS_CONTENT_SELECTOR = hook('js-terms-content');
const TERMS_CHECKBOX_WRAPPER = '.js-terms-checkbox-wrapper';

class TERMS {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }
    this.element = element;

    this.initSelectors();
    this.initListeners();
  }

  initSelectors() {
    this.terms = document.querySelector(TERMS_CONTENT_SELECTOR);
    this.htmlContent = this.terms.innerHTML;
    const checkboxWrapper = this.element.closest(TERMS_CHECKBOX_WRAPPER);

    if (checkboxWrapper) {
      this.checkbox = checkboxWrapper.querySelector('input');
    }
  }

  initListeners() {
    this.element.addEventListener('click', () => {
      this.openModal();
    });
  }

  openModal() {
    Swal.fire({
      html: this.htmlContent,
      width: 'auto',
      showCloseButton: true,
      showConfirmButton: true,
      showDenyButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonText: `Accept`,
      denyButtonText: `Cancel`,
    }).then(result => {
      /* Read more about isConfirmed, isDenied below */
      if (result.isConfirmed && this.checkbox) {
        this.checkbox.checked = true;
      } else if (result.isDenied && this.checkbox) {
        this.checkbox.checked = false;
      }
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(TRIGGER_SELECTOR).forEach(element => {
    // eslint-disable-next-line no-unused-vars
    const elementCard = new TERMS(element);
  });
});
